// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetBrandCodeApprvService = {};

AssetBrandCodeApprvService.getAssetBrandCodeApprvList = function (userInput) {
  return lossClient({
    url: "/AssetBrand/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetBrandCodeApprvService;
